import React from "react";
import { FormattedMessage } from "react-intl";
import { AESVG } from "./svg";
import { Tooltip } from "react-bootstrap";
import { AEOverlayTrigger } from "../AEOverlayTrigger";

export const BADGES = {
  NEW: {
    variant: "light",
    svg: "/Communication/Shield-user.svg",
  },
  VERIFIED: {
    variant: "secondary",
    svg: "/General/Shield-check.svg",
  },
  PRO: {
    variant: "primary",
    svg: "/General/Thunder.svg",
  },
  TOP_RATED: {
    variant: "warning",
    svg: "/General/Star.svg",
  },
  BLACKLIST: {
    variant: "dark",
    svg: "/Code/Warning-2.svg",
  },
  LEVEL1: {
    variant: "primary",
    svg: "/Navigation/Check.svg",
  },
};

export const ACTIVATION_BADGE = {
  ACTIVE: {
    variant: "success",
    svg: "/General/Visible.svg",
  },
  INACTIVE: {
    variant: "danger",
    svg: "/General/Visible.svg",
  },
};

export const AEUserBadge = ({ id, activationStatus, size = "md" }) => {
  const activationEntry =
    activationStatus !== undefined &&
    (Number(activationStatus) === 1 ? "ACTIVE" : "INACTIVE");

  return (
    <>
      {BADGES[id] && (
        <AEOverlayTrigger
          key={1}
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip_user_padge`}>
              <FormattedMessage id={id} />
            </Tooltip>
          }
        >
          <AESVG
            path={BADGES[id].svg}
            variant={BADGES[id].variant}
            size={size}
          />
        </AEOverlayTrigger>
      )}
      {activationEntry && (
        <AEOverlayTrigger
          key={2}
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip_user_activation_badge`}>
              <FormattedMessage id={activationEntry} />
            </Tooltip>
          }
        >
          <AESVG
            path={ACTIVATION_BADGE[activationEntry].svg}
            variant={ACTIVATION_BADGE[activationEntry].variant}
            size={size}
          />
        </AEOverlayTrigger>
      )}
    </>
  );
};
